<template>
    <div class="d-flex flex-column">
        <div
            class="mt-2 d-flex align-items-md-center justify-content-between gap-0-5 flex-column flex-md-row"
        >
            <!-- Set name -->
            <label
                :for="`input-number--${setIdx}`"
                class="form-label mw-none mb-0 mr-auto"
                v-text="setName"
            />

            <!-- Price per item (Promo Bonded) -->
            <div
                v-if="showItemInput"
                class="d-flex align-items-center gap-0-5 justify-content-between"
            >
                <label
                    class="form-label d-md-none mb-0 mr-auto"
                    v-text="'Cena za sztukę'"
                />
                <money-input
                    :key="keyPricePerItem"
                    class="mw-6rem"
                    :placeholder="itemMaxPrice"
                    :max-promotional-price="itemMaxPrice"
                    :price="pricePerItem"
                    :small="true"
                    :invalid-feedback="isBonded ? '' : undefined"
                    @onInput="updatePriceSet($event)"
                />
            </div>

            <!-- Price set -->
            <div
                class="d-flex align-items-center gap-0-5 justify-content-between"
            >
                <label
                    class="form-label d-md-none mb-0"
                    v-text="setPriceWording"
                />
                <money-input
                    :key="keyPriceSet"
                    class="mw-6rem"
                    :wrapper-custom-class="
                        promotion.type === 'Promo::BondedPercentage'
                            ? 'input-percent-wrapper'
                            : ''
                    "
                    :id="`input-number--${setIdx}`"
                    :placeholder="+(+productSet.price).toFixed(2)"
                    :max-promotional-price="+productSet.price"
                    :price="+priceSet"
                    :small="true"
                    :invalid-feedback="isBonded ? '' : undefined"
                    :disabled="
                        promotion.type === 'Promo::BondedQuota' ||
                            promotion.type === 'Promo::BondedPercentage'
                    "
                    @onChange="sendPrice($event)"
                />
            </div>
        </div>

        <span
            v-if="isBonded && +priceSet > +productSet.price"
            class="input-error text-right pt-1"
        >Wartość nie może przekroczyć maksymalnej ceny zestawu w promocji
            ({{ productSet.price | currency }})</span>
    </div>
</template>

<script>
import promoBonded from '@/mixins/promoBonded'
export default {
    data() {
        return {
            pricePerItem: null,
            priceSet: null,
            originalPrice: null,
            keyPriceSet: 0,
            keyPricePerItem: 0
        }
    },
    mixins: [promoBonded],
    props: {
        productSet: {
            type: Object,
            required: true
        },
        setIdx: {
            type: Number,
            required: true
        },
        promotion: {
            type: Object,
            required: true
        },
        groupId: {
            type: Number,
            default: 0
        },
        merchantId: {
            type: Number,
            required: false
        },
        merchantIds: {
            type: Array,
            required: false
        },
        groupIdx: {
            type: Number,
            required: false
        }
    },
    watch: {
        priceChange(val) {
            this.$emit('priceChange', val)
        }
    },
    computed: {
        priceChange() {
            return this.productPrice !== this.originalPrice
        },
        productPrice() {
            const set = this.productSet
            const price =
                this.$store.getters.getSelectedSubscriptionProductSetPrice(
                    this.promotion.id,
                    this.productSet.id,
                    this.merchantId,
                    this.groupIdx,
                    this.groupId
                )

            let setPrice
            if (this.promotion.type === 'Promo::BondedQuota') {
                setPrice = -(set.discount_amount * +set.required_weight)
            } else if (this.promotion.type === 'Promo::BondedPercentage') {
                setPrice = -set.discount_percentage
            } else {
                setPrice = +set.price
            }

            return price || setPrice
        },
        isSetPromotional() {
            return this.productSet?.type === 'ProductSet::Promotional'
        },
        setName() {
            return this.isSetPromotional
                ? 'Zestaw produktów rabatowanych'
                : `Zestaw ${this.setIdx + 1}`
        },
        setPriceWording() {
            if (this.promotion.type === 'Promo::BondedQuota') {
                return 'Rabat brutto do zestawu'
            } else if (this.promotion.type === 'Promo::BondedPercentage') {
                return 'Rabat % do zestawu'
            } else {
                return 'Twoja cena zestawu w promocji'
            }
        },
        promotionalItems() {
            const setPromotional = this.promotion.product_sets.find(
                (set) => set.type === 'ProductSet::Promotional'
            )
            if (setPromotional) {
                return +setPromotional.required_weight
            } else return 1
        },
        itemMaxPrice() {
            const setPrice = +this.productSet.price
            const setWeight = +this.productSet.required_weight
            return setPrice / setWeight
        }
    },
    methods: {
        sendPrice(event) {
            this.priceSet = event
            if (this.isBonded) {
                this.pricePerItem = +(+this.priceSet / this.promotionalItems)
                this.keyPricePerItem++
            }

            this.setPriceSet()
        },
        updatePriceSet(event) {
            this.priceSet = (event * this.promotionalItems).toFixed(2)
            this.keyPriceSet++

            this.setPriceSet()
        },
        setPriceSet() {
            this.$store.dispatch('setSubscriptionProductSetPrice', {
                promoId: this.promotion.id,
                setId: this.productSet.id,
                setPrice: this.priceSet,
                merchantId: this.merchantId,
                groupIdx: this.groupIdx,
                groupId: this.groupId
            })
            this.$store.dispatch('checkPricesErrors')
        }
    },
    created() {
        this.priceSet = +this.productPrice
        this.originalPrice = this.priceSet

        if (this.isBonded) {
            this.pricePerItem = this.priceSet / this.promotionalItems
        }
    }
}
</script>

<style lang="scss" scoped>
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
